import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './Contexts/AuthContext';  // <-- Import AuthProvider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>         {/* Wrap your app inside AuthProvider */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);
